import React, { useMemo, useState } from 'react';
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';

export default function ImportNewClientDialog({ open, onClose, onSubmit }) {
  const sampleClients = useMemo(
    () => [
      { id: 101, name: 'A2 Milk' },
      { id: 102, name: 'Bachan’s' },
      { id: 103, name: 'Nom Nom' },
      { id: 104, name: 'Kodiak Cakes' },
      { id: 105, name: 'Liquid I.V.' },
    ],
    [],
  );

  const [selected, setSelected] = useState(null);

  const handleClose = () => {
    setSelected(null);
    onClose?.();
  };

  const handleImport = () => {
    if (!selected) return;
    onSubmit?.(selected);
    setSelected(null);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Import New Client</DialogTitle>
      <DialogContent>
        <Autocomplete
          options={sampleClients}
          getOptionLabel={(o) => o?.name || ''}
          value={selected}
          onChange={(e, v) => setSelected(v)}
          renderInput={(params) => (
            <TextField {...params} label="Client Name" placeholder="Select a client to import" margin="dense" />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleImport} variant="contained" disabled={!selected}>
          Import
        </Button>
      </DialogActions>
    </Dialog>
  );
}
